import React, { Component } from "react"
import Accordion from "../../../styleguide/js/components/accordion"
import * as tracking from "../../helpers/tracking"

class FaqElement extends Component {
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
    this.triggerRef = React.createRef()
  }

  state = {
    questionExpanded: false,
  }

  componentDidMount() {
    if (this.containerRef.current) {
      new Accordion({
        el: this.containerRef.current,
        eventName: Accordion.EVENT.CLICK,
        disposable: false,
        persistentElement: null,
      })
      // bind only once hack, included library is not doing double binding checks, sic!
      this.containerRef.current = null
    }
    this.triggerRef.current.onclick = () => this.handleExpandCollapse()
  }

  handleExpandCollapse = () => {
    const question = this.props.faqElementContent.question
    var eventAction = this.state.questionExpanded ? "faq - collapse" : "faq - expand"
    var eventLabel = `step ${this.props.step} - ${question}`
    tracking.trackParkingFlowClick(eventAction, eventLabel, this.props)
    this.setState({ questionExpanded: !this.state.questionExpanded })
  }

  render() {
    const faq = this.props.faqElementContent

    return (
      <div className="accordion js--accordion is-bound" ref={this.containerRef}>
        <div className="accordion__trigger js--accordion-trigger" ref={this.triggerRef}>
          <div className="accordion__title">
            <span dangerouslySetInnerHTML={{ __html: faq.question }}></span>
            <span className="icon">
              <svg className="svg-icon svg-icon--arrowdownangle">
                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowdownangle">
                  &nbsp;
                </use>
              </svg>
            </span>
          </div>
        </div>
        <div className="accordion__content js--accordion-content" style={{ maxHeight: "0px" }}>
          <div className="rich-text">
            <span dangerouslySetInnerHTML={{ __html: faq.answer }}></span>
            <p></p>
          </div>
        </div>
      </div>
    )
  }
}

export default FaqElement
